import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest } from 'utilities/service.utils';
import AppService from './app.service.context';

export const getAutodeskAccessToken = async (enquiryId?: number) => {
  const urlBuilder = createUrlBuilder(`/system/asp/auth/token`);

  if (enquiryId) {
    urlBuilder.addParameter('enquiryId', enquiryId);
  }

  return await getRequest(AppService, urlBuilder.toString());
};

export const getAutodeskFileDetail = async (
  fileId: string,
  enquiryId?: number
) => {
  const urlBuilder = createUrlBuilder(`/system/files/${fileId}`);

  urlBuilder.addParameter('format', 'asp');

  if (enquiryId) {
    urlBuilder.addParameter('enquiryId', enquiryId);
  }

  return await getRequest(AppService, urlBuilder.toString());
};
